import React from 'react'
import Head from 'next/head'
import BreadcrumbScroll from '../../../components/Elements/BreadcrumbScroll/BreadcrumbScroll'
import SingleLeaderHeaderSummery from '../../../components/LeadershipCompo/SingleLeaderHeaderSummery/SingleLeaderHeaderSummery'
import { jDateFormatter } from '../../../lib/dateFormater'
import RelatedRow from '../../../components/Elements/RelatedRow/RelatedRow'

const SingleLeadershipPage = ({ leaderMainNoteData, listOfPostData }) => {
  return (
    <>
      <Head>
        <title>{`${leaderMainNoteData?.first_name_fa} ${leaderMainNoteData?.last_name_fa} - راهبران دیجی‌کالا`}</title>
        <meta
          name='viewport'
          content='initial-scale=1.0, width=device-width, maximum-scale=1'
        />
        <meta charSet='utf-8' />
        <meta
          name='description'
          content={leaderMainNoteData?.meta_description_fa}
        />
        <link rel='icon' type='image/x-icon' href='/faviconNew.svg'></link>
        <meta
          name='robots'
          content='index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
        />
        <link
          rel='canonical'
          href={`https://about.digikala.com/leadership/${leaderMainNoteData?.id}/`}
        />
        <meta property='og:locale' content='fa_IR' />
        <meta property='og:type' content='website' />
        <meta
          property='og:title'
          content={`${leaderMainNoteData?.first_name_fa} ${leaderMainNoteData?.last_name_fa} - راهبران دیجی‌کالا`}
        />
        <meta
          property='og:url'
          content={`https://about.digikala.com/leadership/${leaderMainNoteData?.id}/`}
        />
        <meta property='og:site_name' content='درباره گروه دیجی‌کالا' />
        <meta
          property='og:image'
          itemProp='image'
          content={leaderMainNoteData?.avatar_img}
        />
        <meta property='og:image:width' content='500' />
        <meta property='og:image:height' content='500' />
        <meta
          property='og:image:alt'
          content={`${leaderMainNoteData?.first_name_fa} ${leaderMainNoteData?.last_name_fa} - راهبران دیجی‌کالا`}
        />
        <meta property='og:image:type' content='image/png' />
        <meta
          property='og:site_name'
          content={`${leaderMainNoteData?.first_name_fa} ${leaderMainNoteData?.last_name_fa} - راهبران دیجی‌کالا`}
          key='ogsitename'
        />
        <meta
          property='og:title'
          content={`${leaderMainNoteData?.first_name_fa} ${leaderMainNoteData?.last_name_fa} - راهبران دیجی‌کالا`}
          key='ogtitle'
        />
        <meta
          property='og:description'
          content={leaderMainNoteData?.meta_description_fa}
          key='ogdesc'
        />
        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content={`${leaderMainNoteData?.first_name_fa} ${leaderMainNoteData?.last_name_fa} - راهبران دیجی‌کالا`}
        />
        <meta name='twitter:site' content='درباره گروه دیجی‌کالا' />
        <meta name='twitter:image' content={leaderMainNoteData?.avatar_img} />
        <meta
          name='twitter:description'
          content={leaderMainNoteData?.meta_description_fa}
        />
      </Head>
      <BreadcrumbScroll
        title={
          leaderMainNoteData?.first_name_fa +
          ' ' +
          leaderMainNoteData?.last_name_fa
        }
        routeOne='/leadership'
        titleOne='راهبران'
        routeTwo={`/leadership/${leaderMainNoteData?.id}`}
        titleTow={
          leaderMainNoteData?.first_name_fa +
          ' ' +
          leaderMainNoteData?.last_name_fa
        }
      />

      <div className='breadCrumbSpacer'></div>
      <SingleLeaderHeaderSummery leader={leaderMainNoteData} />

      {
        <RelatedRow
          title={`نوشته‌های ${
            leaderMainNoteData?.first_name_fa +
            ' ' +
            leaderMainNoteData?.last_name_fa
          }`}
          rowData={listOfPostData?.results?.map(item => ({
            img: item.thumbnail_img,
            imgAlt: item.title,
            title: item.title,
            cat:
              leaderMainNoteData.first_name_fa +
              ' ' +
              leaderMainNoteData.last_name_fa,
            date: jDateFormatter(item?.date_published),
            link: `/blogs/leadership/${item.id}`
          }))}
          rowTitle='نوشته‌ها'
          allItemsLink={`/blogs/leadership/?lead=${leaderMainNoteData.id}`}
        />
      }
    </>
  )
}

export default SingleLeadershipPage

export async function getServerSideProps (context) {
  const leaderID = context.query.leadershipSlug[0]

  try {
    const leaderMainNoteRes = await fetch(
      `https://about.digikala.com/api/v1/leadership/leaders/${leaderID}/?reqDate=${Date.now()}`
    )
    const leaderMainNoteData = await leaderMainNoteRes.json()

    const listOfPostRes = await fetch(
      `https://about.digikala.com/api/v1/blogs/leadership/?is_published=true&language=FA&leader=${leaderID}&reqDate=${Date.now()}`
    )
    const listOfPostData = await listOfPostRes.json()

    return {
      props: {
        leaderMainNoteData: leaderMainNoteData,
        listOfPostData: listOfPostData
      }
    }
  } catch (error) {
    console.error(error)
    return {
      props: {
        leaderMainNoteData: null,
        listOfPostData: null
      }
    }
  }
}
